export const getSizeProps = (size) => {
  switch (size) {
    case 'xs':
      return { fontSize: '12px' };
    case 'md':
      return { fontSize: '24px' };
    case 'sm':
    default:
      return { fontSize: '16px' };
  }
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Spinner/utils/spinnerHelpers.js